// extracted by css-extract-rspack-plugin
export default {"container":"SimpleListViewContainer-module__container__ppAgqoR"};